import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description = "5年ぶりのリニューアルで伸び悩む求人メディア「re-quest/QJ navi」に対し、定量分析・ヒューリスティック分析・ユーザビリティテストの3段階で課題を特定。会員登録の導線設計を最適化し、CVR20%向上を達成した美容業界向け求人サイトのUX/UI改善事例です。"

const primaryImage = "https://www.i3design.jp/ogp_logo.png"

export const seyfertPageMeta: PageMeta = {
  title: "CVR20%向上を実現した求人メディアのデザインリニューアル｜データ分析起点のUX改善事例 | i3DESIGN",
  description,
  keyword: "UIUX フロントエンド開発 CVR改善 デザインリニューアル サイト分析",
  image: primaryImage,
  url: `${SITE_URL}/cases/seyfert/`,
}

export const seyfertSchema = buildCaseStudySchema({
  slug: "seyfert",
  pageTitle: seyfertPageMeta.title,
  description: seyfertPageMeta.description,
  headline: "CVR20%向上 - 美容総合メディアのデザインリニューアル",
  alternativeHeadline: "株式会社セイファート",
  primaryImage,
  images: ["https://www.i3design.jp/ogp_logo.png","https://www.i3design.jp/images/img/cases/seyfert/top.png"],
  clientName: "株式会社セイファート",
  breadcrumbLabel: "CVR20%向上 - 美容総合メディアのデザインリニューアル",
})
